/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Stock_Check_CheckingInputs */

const vi_await_stock_check_checking = /** @type {(inputs: Await_Stock_Check_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra…`)
};

/**

* @param {Await_Stock_Check_CheckingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_stock_check_checking = /** @type {((inputs?: Await_Stock_Check_CheckingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Stock_Check_CheckingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_stock_check_checking(inputs)
});